const doc = [({"en":({"js":({"admin":({"activities":({"children":({"add_sub_activity":"Add sub-activity"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;